const variant = {
  hidden: {
    x: "-100vw",
  },
  visible: {
    x: "0",
    transition: {
      duration: 0.1,
      type: "tween"
    },
  },
  exit: {
    x: "-100vw",
    transition: {
      duration: 1,
      ease: "easeIn",
    },
  },
};

export default variant;
